/* globals App */

import axios from "axios";
import { htmlToElement, parseDataAttr } from "./utils";

export class Rates {
  constructor(container) {
    this.container = container;
    this.dom = {
      loader: container.querySelector("[data-rate-loader]"),
      results: container.querySelector("[data-rate-results]"),
      message: container.querySelector("[data-rate-message]"),
      error: container.querySelector("[data-rate-error]"),
      adminMessages: container.querySelector("[data-rate-admin-messages]"),
      debug: container.querySelector("[data-rate-debug]"),
      debugLink: container.querySelector(".js-debug"),
      back: container.querySelector("[data-rate-back]"),
      submit: container.querySelector("[data-rate-submit]"),
    };
    if (this.dom.debugLink) {
      this.dom.debugLink.addEventListener("click", (e) => {
        e.preventDefault();
        this.dom.debug.querySelector("pre").classList.toggle("hidden");
      });
    }
    console.log("Rates initialised");
  }

  getPackageRates(onSuccess = null) {
    this.onGetRates();
    let data = {
      id: parseDataAttr(this.container, "data-rates-order", ""),
    };
    data[App.settings.csrfTokenName] = App.settings.csrfToken;
    axios
      .post("/?action=site/orders/package-shipping-rates", data, {
        headers: {
          Accept: "application/json",
        },
      })
      .then((response) => {
        this.showRates(response.data);
        if (onSuccess) {
          onSuccess(response.data);
        }
      })
      .catch((error) => {
        this.onError(error.response.data);
      })
      .then(() => {
        this.hideLoader();
      });
  }

  onGetRates() {
    this.hideError();
    this.hideResults();
    this.hideMessage();
    this.hideAdminMessages();
    this.hideDebug();
    this.showLoader();
    this.hideBack();
    this.dom.results.innerHTML = "";
  }

  onError(data) {
    this.hideLoader();
    this.showError();
    if (data.adminMessages) {
      this.addAdminMessages(data.adminMessages);
    }
    this.showBack();
    this.hideSubmit();
    this.showAdminData(data);
  }

  showRates(data) {
    data.html.forEach((rdata) => {
      let rate = htmlToElement(rdata);
      this.dom.results.appendChild(rate);
    });
    this.showResults();
    this.showMessage();
    this.showAdminData(data);
  }

  showAdminData(data) {
    if (data.adminMessages) {
      this.addAdminMessages(data.adminMessages);
    }
    if (data.debug) {
      this.addDebug(data.debug);
    }
  }

  addAdminMessages(messages) {
    if (!this.dom.adminMessages) {
      return;
    }
    let container = this.dom.adminMessages.querySelector("div");
    container.innerHTML = "";
    messages.forEach((message) => {
      container.appendChild(htmlToElement("<p>- " + message + "</p>"));
    });
    this.showAdminMessages();
  }

  addDebug(debug) {
    if (!this.dom.debug) {
      return;
    }
    let container = this.dom.debug.querySelector("pre");
    container.innerHTML = JSON.stringify(debug, null, 2);
    this.showDebug();
  }

  showDebug() {
    if (this.dom.debug) {
      this.dom.debug.classList.remove("hidden");
    }
  }

  hideDebug() {
    if (this.dom.debug) {
      this.dom.debug.classList.add("hidden");
    }
  }

  showAdminMessages() {
    if (this.dom.adminMessages) {
      this.dom.adminMessages.classList.remove("hidden");
    }
  }

  hideAdminMessages() {
    if (this.dom.adminMessages) {
      this.dom.adminMessages.classList.add("hidden");
    }
  }

  showMessage() {
    if (this.dom.message) {
      this.dom.message.classList.remove("hidden");
    }
  }

  hideMessage() {
    if (this.dom.message) {
      this.dom.message.classList.add("hidden");
    }
  }

  showLoader() {
    if (this.dom.loader) {
      this.dom.loader.classList.remove("hidden");
    }
  }

  hideLoader() {
    if (this.dom.loader) {
      this.dom.loader.classList.add("hidden");
    }
  }

  showSubmit() {
    if (this.dom.submit) {
      this.dom.submit.classList.remove("hidden");
    }
  }

  hideSubmit() {
    if (this.dom.submit) {
      this.dom.submit.classList.add("hidden");
    }
  }

  showBack() {
    if (this.dom.back) {
      this.dom.back.classList.remove("hidden");
    }
  }

  hideBack() {
    if (this.dom.back) {
      this.dom.back.classList.add("hidden");
    }
  }

  showError() {
    this.dom.error.classList.remove("hidden");
  }

  hideError() {
    this.dom.error.classList.add("hidden");
  }

  showResults() {
    this.dom.results.classList.remove("hidden");
  }

  hideResults() {
    this.dom.results.classList.add("hidden");
  }
}
